/* eslint-disable */
export default {
  searchPlaceholder: 'Buscar…',
  refresh: 'Actualizar',
} as const;

// @key: @#@"searchPlaceholder"@#@ @source: @#@"Search..."@#@
// @key: @#@"refresh"@#@ @source: @#@"Refresh"@#@
